import { DocumentNode } from '@apollo/client'
import {
  BulkUpdateTasksDocument,
  BulkUpdateTasksMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export interface RefetchQuery {
  query: DocumentNode
  variables?: Record<string, unknown>
}

type BulkUpdateTasksProps = {
  variables: BulkUpdateTasksMutationVariables
  refetchQueries?: RefetchQuery[]
  awaitRefetchQueries?: boolean
}

export const useBulkUpdateTasks = () => {
  const [bulkUpdateTasks, { loading }] = useMutation(BulkUpdateTasksDocument, {
    extractorFn: (data) => data.tasksMutations.bulkUpdateTasksTask,
  })

  return {
    bulkUpdateTasks: ({
      variables,
      refetchQueries,
      awaitRefetchQueries = true,
    }: BulkUpdateTasksProps) => {
      const refetchQueriesOption = refetchQueries
        ? refetchQueries?.map((query) => ({
            query: query.query,
            variables: query.variables,
          }))
        : []
      return bulkUpdateTasks({
        variables,
        ...(refetchQueriesOption.length && {
          refetchQueries: refetchQueriesOption,
          awaitRefetchQueries,
        }),
      })
    },
    loading,
  }
}
